import styled from '@emotion/styled';

interface CustomInputType {
    hasError?: boolean;
}

export const CustomInput = styled.input<CustomInputType>`
    color: #0f172a;
    border: ${(props): string => (props.hasError === true ? '1px solid #ef4444' : '1px solid #dedede')};
    padding: 4px 12px;
    border-radius: 6px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    font-size: 14px;
    font-weight: 400;
    margin-top: 8px;
    margin-bottom: 0;
    outline-color: #a8a8a8;
    :disabled {
        cursor: not-allowed;
    }
`;

export const CustomTextArea = styled.textarea`
    color: #0f172a;
    border: 1px solid #dedede;
    padding: 4px 12px;
    border-radius: 6px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    font-size: 14px;
    font-weight: 400;
    margin-top: 8px;
    margin-bottom: 0;
    outline-color: #a8a8a8;
    min-height: 100px;
    min-width: 650px;
    font-family: inherit;
`;

export const StyledCodeMirror = styled.div`
    width: 50%;
    .cm-theme-light {
        width: 50%;
    }
    .cm-editor {
        border: 1px solid #dedede;
        border-radius: 6px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        margin-top: 8px;
        margin-bottom: 0;
        font-size: 14px;
        font-family: inherit;
        width: 100%;
        max-width: 100%;
    }
    .cm-scroller {
        width: 100%;
    }

    .cm-focused {
        outline-color: #a8a8a8 !important;
    }

    .cm-content {
        color: #0f172a;
        padding: 4px 12px;
    }
`;
